
  import Vue from 'vue'
  import Component from "vue-class-component";
  import {namespace} from "vuex-class";
  import {IOnOffHandlers} from "bonomo/dist";
  import LockerChip from "@/components/shared/chips/LockerChip.vue";
  import {IShortLocker} from "@/model/shortInterfaces";
  import {Watch} from "vue-property-decorator";
  import {ITimeslotRestriction} from "@/store/modules/settingsModule";
  import {IZone} from "@/store/modules/settings/zonesModule";
  import {IErrors} from "@/model/IErrors";
  import {BetterDataTableHeader} from "@/model/betterVuetifyInterfaces";

  const lockerModule = namespace("lockerModule");
  const zonesModule = namespace("zonesModule");

  @Component({
    components: {
      LockerChip
    }
  })
  export default class Zone extends Vue {

    @zonesModule.Getter('zones')
    protected zones!: IZone[];
    @zonesModule.Getter('restrictions')
    protected zoneRestrictions!: ITimeslotRestriction[];
    @zonesModule.Getter('errors')
    protected errors!: IErrors;
    @lockerModule.Getter('lockers')
    protected lockers!: IShortLocker[];

    protected zonesLoading: boolean = false;
    protected lockersLoading: boolean = false;
    protected restrictionsSubmitting: boolean = false;
    protected model: any = null;
    protected editingDeliveries: boolean = false;
    protected createDelivery: any = {
      dayOfWeek: null,
      data: '',
    };

    private subscribes: IOnOffHandlers = {};
    private zoneSelected: number = 0;
    protected get headers(): BetterDataTableHeader[] {
      return [
        { text: this.$t('common.name'), align: 'start', sortable: true, value: 'id' },
      ];
    }

    protected get loading(): boolean {
      return this.zonesLoading || this.lockersLoading;
    }
    protected get zone(): IZone {
      const zone = this.zones.find((each: IZone) => each.id == this.zoneSelected);
      return zone ? zone : {} as IZone;
    }
    protected get items(): IShortLocker[] {
      return this.lockers.filter((each: IShortLocker) => each.zone_id == this.zoneSelected);
    }
    protected get deliveryDayItems(): any[] {
      const weekDays: any = this.$t('common.weekDays');
      return Object.keys(weekDays).map(each => ({
        text: weekDays[each],
        value: each,
      }));
    }
    protected get deliveryHourItems(): any[] {
      let ret = [];
      for (let i=0; i<24; i++) {
        ret.push({
          text: '' + i + 'h',
          value: i,
        });
      }
      return ret;
    }
    protected get createDeliveryDisabled(): boolean {
      return !this.createDelivery.dayOfWeek ||
          !this.createDelivery.data ||
          this.restrictionsSubmitting;
    }

    @Watch('$route')
    private onRouteChanged() {
      this.editingDeliveries = false;
      this.createDelivery.dayOfWeek = null;
      this.createDelivery.data = '';
      this.loadData();
    }

    created() {
      this.subscribes = this.$ons({
        'login.OK': this.loadData,
        'backend.call.OK.zonesLoaded': () => this.zonesLoading = false,
        'backend.call.OK.lockersLoaded': () => this.lockersLoading = false,
        'backend.call.OK.restrictionsLoaded': this.onRestrictionsLoaded,
        'backend.call.KO.restrictionsLoaded': this.onRestrictionsLoaded,
      });
      this.loadData();
    }

    private loadData() {

      this.zoneSelected = parseInt(this.$route.params.zoneId);

      this.zonesLoading = true;
      this.$store.dispatch('zonesModule/fetchZones');
      this.$store.dispatch('zonesModule/fetchZoneRestrictions', this.zoneSelected);
      this.lockersLoading = true;
      this.$store.dispatch('lockerModule/fetchLockers');

    }

    protected onChange(val: IZone) {
      this.$router.push({name: 'zone', params: {zoneId: val.id.toString()}});
    }

    protected onEditDeliveries() {
      this.editingDeliveries = !this.editingDeliveries;
    }

    protected onCreateDelivery() {
      this.restrictionsSubmitting = true;
      this.$store.dispatch('zonesModule/createZoneRestriction', {
        zoneId: this.zoneSelected,
        dayOfWeek: this.createDelivery.dayOfWeek,
        data: this.createDelivery.data,
      });
    }

    protected onDeleteDelivery(restrictionId: number) {
      this.restrictionsSubmitting = true;
      this.$store.dispatch('zonesModule/deleteZoneRestriction', {
        zoneId: this.zoneSelected,
        restrictionId
      });
    }

    private onRestrictionsLoaded() {
      this.restrictionsSubmitting = false;
    }

  }

